import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CtaButton } from "./CtaButton";

// Phone-only sticky CTA: shows after the hero, hides while an inline signup form is on screen.
export const StickyMobileCta = () => {
  const [pastHero, setPastHero] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    const seen = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
      setFormVisible(seen.size > 0);
    });
    document.querySelectorAll("[data-signup-zone]").forEach((el) => io.observe(el));
    return () => {
      window.removeEventListener("scroll", onScroll);
      io.disconnect();
    };
  }, []);

  const show = pastHero && !formVisible;
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-mobile-cta"
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed inset-x-0 bottom-0 z-[35] border-t border-navy/10 bg-cream/95 px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl md:hidden"
        >
          <CtaButton testId="sticky-mobile-cta-button" source="sticky-mobile" className="w-full" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
